import { createContext } from 'react'

export const initialState = {
  isModalOpen: false,
}

const ModalContext = createContext(initialState)

export default ModalContext
